import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './locales/en.json';
import ptTranslations from './locales/pt.json';

console.log('Initializing i18n with Portuguese as default language');

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslations,
    },
    pt: {
      translation: ptTranslations,
    },
  },
  lng: 'pt', // Force Portuguese as default
  fallbackLng: 'pt',
  interpolation: {
    escapeValue: false,
  },
});

// Always set Portuguese in localStorage
localStorage.setItem('preferredLanguage', 'pt');

export default i18n;